(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fendo-brand-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fendo-brand-motion')) {
  customElements.define('fendo-brand-motion', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.fendo-brand-story');
      this.button = this.querySelector('button');
      this.media = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.revealed = false;
      this.paused = false;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.update = () => {
        const reduced = this.media.matches && this.dataset.respectReduced === 'true';
        const active = this.visible && !this.paused && !reduced && !document.hidden;
        this.root.classList.toggle('fbs--running', active);
        this.root.classList.toggle('fbs--paused', !active);
        this.root.classList.toggle('fbs--reduced', reduced);
        this.root.classList.toggle('fbs--respect-reduced', this.dataset.respectReduced === 'true');
      };
      this.button?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.button.setAttribute('aria-pressed', String(this.paused));
        this.update();
      }, options);
      document.addEventListener('visibilitychange', this.update, options);
      this.media.addEventListener('change', this.update, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible && !this.revealed) {
          this.revealed = true;
          this.root.classList.add('fbs--revealed');
        }
        this.update();
      }, { threshold: 0.05 });
      this.observer.observe(this.root);
      this.root.classList.add('fbs--animated');
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.root?.classList.remove('fbs--animated', 'fbs--running', 'fbs--paused');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
